import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import React, { Fragment, useMemo } from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import { useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
import { Tooltip } from '../Tooltip/Tooltip';
import { Type } from '../Type/Type';
import { AdvertiserDisclosureMessage, PRODUCT_TYPES } from './AdvertiserDisclosureMessage';
import styles from './AdvertiserDisclosure.module.less';
export var AdvertiserDisclosure = function AdvertiserDisclosure(_ref) {
  var onBackground = _ref.onBackground,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? PRODUCT_TYPES.CREDIT_CARDS : _ref$type,
      enableAnalytics = _ref.enableAnalytics,
      analyticsProps = _ref.analytics,
      children = _ref.children,
      color = _ref.color,
      label = _ref.label,
      shouldDelay = _ref.shouldDelay;
  useDeprecatedPropsWarning({
    component: 'AdvertiserDisclosure',
    deprecatedProps: [{
      deprecated: 'children',
      migration: 'Use the type prop to render the standard, compliance-approved message for your product type.',
      version: '5.6.0'
    }, {
      deprecated: 'color',
      migration: 'All components will have the same blue color.',
      version: '5.5.0'
    }, {
      deprecated: 'label',
      migration: "All components will have the same default label, 'Advertiser disclosure.'",
      version: '5.5.0'
    }, {
      deprecated: 'shouldDelay',
      migration: 'AdvertiserDisclosure no longer hovers.  It is a toggle tip (<Tooltip />). As a result, delayed toggling of visibility on hover events is not possible.',
      version: '5.13.0'
    }],
    props: {
      children: children,
      color: color,
      label: label,
      shouldDelay: shouldDelay
    }
  }); // tooltip analytics configuration

  var analytics = useMemo(function () {
    return enableAnalytics && _objectSpread({
      entityName: 'advertiser_disclosure'
    }, analyticsProps);
  }, [enableAnalytics, analyticsProps]);
  return /*#__PURE__*/React.createElement(Tooltip, {
    id: "advertiser-disclosure-popover" // TODO: can we change this to "advertiser-disclosure"?
    ,
    "aria-label": "Advertiser Disclosure",
    analytics: analytics,
    className: classNames(styles['ad-trigger'], _defineProperty({}, styles['on-background'], onBackground)),
    content: /*#__PURE__*/React.createElement("div", {
      className: classes(['text-default', 'color-neutral-darkest', 'max-width-prose-narrow', 'max-width-prose-wide--wide'])
    }, children || /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Type, {
      bold: true,
      className: classes('margin-bottom-3'),
      color: "green",
      component: "h3",
      size: "3"
    }, "You\u2019re our first priority.", /*#__PURE__*/React.createElement("br", null), "Every time."), /*#__PURE__*/React.createElement(AdvertiserDisclosureMessage, {
      type: type
    })))
  }, label || 'Advertiser disclosure');
};
export { PRODUCT_TYPES };